/* ============================================================
   línkè · 壁纸位置调整器（2026-07-12）
   铃的需求原话：「选完图尺寸和屏幕对不上，没办法移动或缩放」。
   全屏预览 = 真实渲染同一份 wallpaperImgStyle（所见即所得）：
   - 单指/鼠标拖动 → 平移（object-position 百分比）
   - 滑条 → 缩放（cover 基础上 1x~3x）
   - 重置 / 取消 / 保存√
   ============================================================ */
import { useRef, useState } from 'react';
import { clampPos, DEFAULT_POS, wallpaperImgStyle } from '../lib/wallpaper.js';
import './WallpaperAdjust.css';

export default function WallpaperAdjust({ img, pos, dim = 0, blur = false, onSave, onClose }) {
  const [p, setP] = useState(() => clampPos(pos || DEFAULT_POS));
  const dragRef = useRef(null); // {startX, startY, baseX, baseY, w, h}
  const boxRef = useRef(null);

  function onPointerDown(e) {
    const box = boxRef.current;
    if (!box) return;
    box.setPointerCapture?.(e.pointerId);
    const r = box.getBoundingClientRect();
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      baseX: p.x,
      baseY: p.y,
      w: r.width,
      h: r.height,
    };
  }

  function onPointerMove(e) {
    const d = dragRef.current;
    if (!d) return;
    // 手指往右拖 = 想看图的左边 = object-position x 变小 → 位移取反。
    // 放大越多可移动余量越大，除以 scale 让手感跟手（图跟着手指走，不飘）。
    const dx = ((e.clientX - d.startX) / d.w) * 100;
    const dy = ((e.clientY - d.startY) / d.h) * 100;
    setP((prev) =>
      clampPos({ ...prev, x: d.baseX - dx / prev.scale, y: d.baseY - dy / prev.scale }),
    );
  }

  function onPointerUp() {
    dragRef.current = null;
  }

  if (!img) return null;

  return (
    <div className="wpadj-overlay" role="dialog" aria-label="调整壁纸位置">
      <div
        className="wpadj-stage"
        ref={boxRef}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
      >
        <img src={img} alt="" style={wallpaperImgStyle(p, blur)} draggable={false} />
        {dim > 0 && <div className="wpadj-veil" style={{ opacity: dim / 100 }} />}
        <div className="wpadj-hint">拖动图片调整位置</div>
      </div>

      <div className="wpadj-panel">
        <label className="wpadj-scale-label">
          缩放 <span className="wpadj-scale-val">{Math.round(p.scale * 100)}%</span>
        </label>
        <input
          type="range"
          min="100"
          max="300"
          step="5"
          value={Math.round(p.scale * 100)}
          onChange={(e) =>
            setP((prev) => clampPos({ ...prev, scale: parseInt(e.target.value, 10) / 100 }))
          }
          className="wpadj-slider"
        />
        <div className="wpadj-btns">
          <button type="button" className="wpadj-btn" onClick={() => setP({ ...DEFAULT_POS })}>
            重置
          </button>
          <button type="button" className="wpadj-btn" onClick={onClose}>
            取消
          </button>
          <button
            type="button"
            className="wpadj-btn wpadj-btn-save"
            onClick={() => {
              onSave?.(clampPos(p));
              onClose?.();
            }}
          >
            保存 ✓
          </button>
        </div>
      </div>
    </div>
  );
}
